module.exports = __webpack_public_path__ + "img/Withdraw-icon.cf0e302f.svg";